module.exports = new __parcel__URL__("createViewDark.bbb69103.svg").toString();